<template>
  <div class="download">
      <Header :isbig="true" @changeLogin="changeLogin"></Header>
      <div class="homeCon">
        <div class="section section1">
            <div class="fl s-con s1-con">
                <div class="s1-con-info1 font-MT">
                    <i style="font-style: normal" class="text-success">MeetNovel</i> - Meet Your Next Favorite Novel!
                </div>
                <div class="s1-con-info1 text-default font-AB mt0">
                    One of the Best Novel Reading<br>
                    & Writing Platform
                </div>
                <div class="font-MT text-muted f20 mt10 text-line30">
                    Talented Writers All Around the World Will Present a Fantastic
                    <br>
                    Reading Feast for You!
                </div>
<!--                <div class="center">-->
<!--                    <a class="download-btn mr20" href="https://apps.apple.com/us/app/id6443915856"><img src="../assets/account/btn_iphone.png"/></a>-->
<!--                    &lt;!&ndash;<a class="download-btn mr20" href="https://apps.apple.com/us/app/meetfic/id1615532334"><img src="../assets/account/btn_iphone.png"/></a>&ndash;&gt;-->
<!--                    <a class="download-btn" href="https://play.google.com/store/apps/details?id=com.adoread.book"><img src="../assets/account/btn_android.png"/></a>-->
<!--                </div>-->
            </div>
            <div class="fr">
                <img src="@/assets/account/bg_HAI.png" class="download-img1"/>
            </div>
        </div>
    </div>
      <Footer :big="true"></Footer>
      <Login @changeLogin="changeLogin" v-if="isshowlogin"></Login>
  </div>
</template>

<script>
    import index from '@/mixins/index'
    import "utils/lib/rem";
    export default {
        mixins: [index],
    };
</script>

<style lang="stylus" scoped>
    .download
        width 100%
        background #fff
        position relative
        .homeCon
            width 100%
            .section
                width 1200px
                display table
                margin auto
                position relative
                .homeBigSwiper
                    width 1200px
                    margin auto
                    margin-top 70px
                .s-con
                    position absolute
                    top 0
                    left 0
                .s1-con-info1
                    font-size 30px
                    line-height 66px
                    margin-top 50px
                    span
                        background #000
                        color #fff
                        padding 0 10px
                &.section1
                    margin-top 100px
                    margin-bottom 156px
                    .download-img1
                        width 761px
                        height 657px
                    .center
                        margin-top 66px

</style>
